import { render, staticRenderFns } from "./Browser.vue?vue&type=template&id=4a8cd0ca&"
import script from "./Browser.vue?vue&type=script&lang=js&"
export * from "./Browser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports